


import { fetchRunsheetOrdersByShift } from '@/entities/orders/thunks/fetchRunsheetOrdersByShift'
import { selectAllRunsheetsWithShifts } from '@/entities/schedules'
import { widgetWindowsSelector } from '@/entities/widgetWindows'
import { OperationsGanttWidgetWindow } from '@/entities/widgetWindows/models/WidgetWindow'
import { updateWidgetWindow } from '@/entities/widgetWindows/widgetWindowsSlice'
import { MosaicAdditionalToolbar } from '@/shared/components'
import { DropdownOption } from '@/shared/components/FilterMultiselectDropdown/FilterMultiselectDropdown'
import { useGanttContext } from '@/shared/components/GanttChart/GanttContext'
import { MosaicToolbarMenuItem } from '@/shared/components/MosaicAdditionalToolbar/models/MosaicToolbarMenuItem'
import { useAppDispatch, useAppSelector } from '@/shared/store'
import { faTrash } from '@fortawesome/pro-regular-svg-icons'

import { useOperationsGanttContext } from './OperationsGanttChartContext'

export type RunsheetOperationsGanttWidgetToolbarProps = {
  //
}

// TODO: Add an API endpoint to retrieve the list of shifts for the dropdown filter
export const RunsheetOperationsGanttWidgetToolbar: React.FC<RunsheetOperationsGanttWidgetToolbarProps> = () => {
  const { widgetId } = useOperationsGanttContext()
  const { zoom, setZoom } = useGanttContext()
  const ganttWidget = useAppSelector((state) => widgetWindowsSelector.selectById(state, widgetId))
  const selectedShiftIds = (ganttWidget as OperationsGanttWidgetWindow)?.shiftIds || []
  const dispatch = useAppDispatch()
  const runsheetScenariosWithShifts = useAppSelector((state) => selectAllRunsheetsWithShifts(state))

  // Optional TODO: Create an API endpoint to retrieve the list of shifts for the dropdown filter
  const runsheetShiftOptions: DropdownOption[] = runsheetScenariosWithShifts.flatMap((runsheet) =>
    runsheet.shifts.map((shift) => ({ label: `${runsheet.name} > ${shift.name}`, value: shift.id })),
  )

  const selectedShiftOptions = selectedShiftIds
    .map((shiftId) => runsheetShiftOptions.find((option) => option.value === shiftId))
    .filter(option => option !== undefined)

  const handleSelectShift = (val: DropdownOption) => {
    const index = selectedShiftIds.findIndex(id => id === val.value)

    if (index > -1) {
      const newSelectedShiftIds = [...selectedShiftIds]

      newSelectedShiftIds.splice(index, 1)

      dispatch(updateWidgetWindow({
        id: widgetId,
        changes: {
          shiftIds: newSelectedShiftIds,
        },
      }))
    } else {
      const newSelectedShiftIds = [...selectedShiftIds, val.value]

      dispatch(fetchRunsheetOrdersByShift({ shiftId: val.value }))
      dispatch(updateWidgetWindow({
        id: widgetId,
        changes: {
          shiftIds: newSelectedShiftIds,
        },
      }))
    }
  }
  
  const handleClearAllShifts = () => {
    dispatch(updateWidgetWindow({
      id: widgetId,
      changes: {
        shiftIds: [],
      },
    }))
  }

  const toolbarMenuItems: MosaicToolbarMenuItem[] = [
    {
      type: 'multidropdown',
      label: 'Vehicle Shifts',
      values: (selectedShiftOptions as DropdownOption[]),
      options: runsheetShiftOptions,
      onSelectItem: handleSelectShift,
      searchActionEnable: true,
      searchActionIcon: faTrash,
      slotProps: {
        search: {
          placeholder: 'Search scenario shifts',
        },
        searchAction: {
          onClick: handleClearAllShifts,
          tooltipTitle: 'Clear selected shifts',
          disabled: selectedShiftIds.length === 0,
        },
      },
    },
    {
      type: 'slider',
      label: 'Zoom',
      float: 'right',
      value: zoom,
      min: 1,
      max: 7,
      step: 0.1,
      onChange: (_, value) => setZoom(value as number),
    },
  ]

  return (
    <MosaicAdditionalToolbar
      toolbarMenuItems={toolbarMenuItems}
      averageMenuItemWidth={120}
    />
  )
}
